module.exports = __webpack_public_path__ + "static/component-boxes-e893d8acc0c81287622b3283e34ec2d2.jpg";